import { useEffect, useState } from "react"
import { fetchAllPostPromisedData } from "../views/pages/manage/common/utils/methods/commonMethods/utilityMethod"
import { endpoint } from "../views/pages/manage/common/constant"
import { useHistory } from "react-router-dom";
import { failureToast } from "../views/pages/manage/common/utils/methods/toasterFunctions/function";

export const isInValidStdOutView = async ({
    bu,
    applicationId,
    psid
}) => {
    const resp = await fetchAllPostPromisedData(`${endpoint.stdOutCompare}?bu=${bu}&applicationId=${applicationId}&psid=${psid}`, {});
    if (resp?.code === 200) {
        const isInvalid = resp?.data;

        if (isInvalid) {
            failureToast("There is a data mismatch between PSERP and Phoenix for the provided application ID.");
        }

        return isInvalid;
    }
}

const useValidateStdOutView = ({
    bu,
    applicationId,
    psid
}) => {

    const history = useHistory();
    const [checkingStdOutValidity, setCheckingStdOutValidity] = useState(false);

    useEffect(() => {
        const checkStdOutValidity = async () => {
            try {
                setCheckingStdOutValidity(true);

                if (await isInValidStdOutView({ bu, applicationId, psid })) {
                    history.length > 1 ? history.goBack() : history.push('/admin/dashboard');
                }
            } catch (err) {
                console.error(err);
            } finally {
                setCheckingStdOutValidity(false);
            }
        }
        bu && applicationId && psid && checkStdOutValidity();

    }, [bu, applicationId, psid])

    return { checkingStdOutValidity };

}

export default useValidateStdOutView;